import _slicedToArray from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _construct from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/construct";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _wrapNativeSuper from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import "core-js/modules/es.array.sort.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { illegalState } from '../../../base/common/errors.js';
import { Graph } from './graph.js';
import { SyncDescriptor } from './descriptors.js';
import { IInstantiationService, _util, optional } from './instantiation.js';
import { ServiceCollection } from './serviceCollection.js';
import { IdleValue } from '../../../base/common/async.js'; // TRACING

var _enableTracing = false;

var CyclicDependencyError = /*#__PURE__*/function (_Error) {
  _inherits(CyclicDependencyError, _Error);

  var _super = _createSuper(CyclicDependencyError);

  function CyclicDependencyError(graph) {
    var _this;

    _classCallCheck(this, CyclicDependencyError);

    _this = _super.call(this, 'cyclic dependency between services');
    _this.message = graph.toString();
    return _this;
  }

  return CyclicDependencyError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

export var InstantiationService = /*#__PURE__*/function () {
  function InstantiationService() {
    var services = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new ServiceCollection();
    var strict = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var parent = arguments.length > 2 ? arguments[2] : undefined;

    _classCallCheck(this, InstantiationService);

    this._services = services;
    this._strict = strict;
    this._parent = parent;

    this._services.set(IInstantiationService, this);
  }

  _createClass(InstantiationService, [{
    key: "createChild",
    value: function createChild(services) {
      return new InstantiationService(services, this._strict, this);
    }
  }, {
    key: "invokeFunction",
    value: function invokeFunction(fn) {
      var _this2 = this;

      var _trace = Trace.traceInvocation(fn);

      var _done = false;

      try {
        var accessor = {
          get: function get(id, isOptional) {
            if (_done) {
              throw illegalState('service accessor is only valid during the invocation of its target method');
            }

            var result = _this2._getOrCreateServiceInstance(id, _trace);

            if (!result && isOptional !== optional) {
              throw new Error("[invokeFunction] unknown service '".concat(id, "'"));
            }

            return result;
          }
        };

        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        return fn.apply(void 0, [accessor].concat(args));
      } finally {
        _done = true;

        _trace.stop();
      }
    }
  }, {
    key: "createInstance",
    value: function createInstance(ctorOrDescriptor) {
      var _trace;

      var result;

      for (var _len2 = arguments.length, rest = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        rest[_key2 - 1] = arguments[_key2];
      }

      if (ctorOrDescriptor instanceof SyncDescriptor) {
        _trace = Trace.traceCreation(ctorOrDescriptor.ctor);
        result = this._createInstance(ctorOrDescriptor.ctor, ctorOrDescriptor.staticArguments.concat(rest), _trace);
      } else {
        _trace = Trace.traceCreation(ctorOrDescriptor);
        result = this._createInstance(ctorOrDescriptor, rest, _trace);
      }

      _trace.stop();

      return result;
    }
  }, {
    key: "_createInstance",
    value: function _createInstance(ctor) {
      var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      var _trace = arguments.length > 2 ? arguments[2] : undefined;

      // arguments defined by service decorators
      var serviceDependencies = _util.getServiceDependencies(ctor).sort(function (a, b) {
        return a.index - b.index;
      });

      var serviceArgs = [];

      var _iterator = _createForOfIteratorHelper(serviceDependencies),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var dependency = _step.value;

          var service = this._getOrCreateServiceInstance(dependency.id, _trace);

          if (!service && this._strict && !dependency.optional) {
            throw new Error("[createInstance] ".concat(ctor.name, " depends on UNKNOWN service ").concat(dependency.id, "."));
          }

          serviceArgs.push(service);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var firstServiceArgPos = serviceDependencies.length > 0 ? serviceDependencies[0].index : args.length; // check for argument mismatches, adjust static args if needed

      if (args.length !== firstServiceArgPos) {
        console.warn("[createInstance] First service dependency of ".concat(ctor.name, " at position ").concat(firstServiceArgPos + 1, " conflicts with ").concat(args.length, " static arguments"));
        var delta = firstServiceArgPos - args.length;

        if (delta > 0) {
          args = args.concat(new Array(delta));
        } else {
          args = args.slice(0, firstServiceArgPos);
        }
      } // now create the instance


      return _construct(ctor, [].concat(_toConsumableArray(args), serviceArgs));
    }
  }, {
    key: "_setServiceInstance",
    value: function _setServiceInstance(id, instance) {
      if (this._services.get(id) instanceof SyncDescriptor) {
        this._services.set(id, instance);
      } else if (this._parent) {
        this._parent._setServiceInstance(id, instance);
      } else {
        throw new Error('illegalState - setting UNKNOWN service instance');
      }
    }
  }, {
    key: "_getServiceInstanceOrDescriptor",
    value: function _getServiceInstanceOrDescriptor(id) {
      var instanceOrDesc = this._services.get(id);

      if (!instanceOrDesc && this._parent) {
        return this._parent._getServiceInstanceOrDescriptor(id);
      } else {
        return instanceOrDesc;
      }
    }
  }, {
    key: "_getOrCreateServiceInstance",
    value: function _getOrCreateServiceInstance(id, _trace) {
      var thing = this._getServiceInstanceOrDescriptor(id);

      if (thing instanceof SyncDescriptor) {
        return this._createAndCacheServiceInstance(id, thing, _trace.branch(id, true));
      } else {
        _trace.branch(id, false);

        return thing;
      }
    }
  }, {
    key: "_createAndCacheServiceInstance",
    value: function _createAndCacheServiceInstance(id, desc, _trace) {
      var graph = new Graph(function (data) {
        return data.id.toString();
      });
      var cycleCount = 0;
      var stack = [{
        id: id,
        desc: desc,
        _trace: _trace
      }];

      while (stack.length) {
        var item = stack.pop();
        graph.lookupOrInsertNode(item); // a weak but working heuristic for cycle checks

        if (cycleCount++ > 1000) {
          throw new CyclicDependencyError(graph);
        } // check all dependencies for existence and if they need to be created first


        var _iterator2 = _createForOfIteratorHelper(_util.getServiceDependencies(item.desc.ctor)),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var dependency = _step2.value;

            var instanceOrDesc = this._getServiceInstanceOrDescriptor(dependency.id);

            if (!instanceOrDesc && !dependency.optional) {
              console.warn("[createInstance] ".concat(id, " depends on ").concat(dependency.id, " which is NOT registered."));
            }

            if (instanceOrDesc instanceof SyncDescriptor) {
              var d = {
                id: dependency.id,
                desc: instanceOrDesc,
                _trace: item._trace.branch(dependency.id, true)
              };
              graph.insertEdge(item, d);
              stack.push(d);
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }

      while (true) {
        var roots = graph.roots(); // if there is no more roots but still
        // nodes in the graph we have a cycle

        if (roots.length === 0) {
          if (!graph.isEmpty()) {
            throw new CyclicDependencyError(graph);
          }

          break;
        }

        var _iterator3 = _createForOfIteratorHelper(roots),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var data = _step3.value.data;

            // create instance and overwrite the service collections
            var instance = this._createServiceInstanceWithOwner(data.id, data.desc.ctor, data.desc.staticArguments, data.desc.supportsDelayedInstantiation, data._trace);

            this._setServiceInstance(data.id, instance);

            graph.removeNode(data);
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }

      return this._getServiceInstanceOrDescriptor(id);
    }
  }, {
    key: "_createServiceInstanceWithOwner",
    value: function _createServiceInstanceWithOwner(id, ctor) {
      var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      var supportsDelayedInstantiation = arguments.length > 3 ? arguments[3] : undefined;

      var _trace = arguments.length > 4 ? arguments[4] : undefined;

      if (this._services.get(id) instanceof SyncDescriptor) {
        return this._createServiceInstance(ctor, args, supportsDelayedInstantiation, _trace);
      } else if (this._parent) {
        return this._parent._createServiceInstanceWithOwner(id, ctor, args, supportsDelayedInstantiation, _trace);
      } else {
        throw new Error("illegalState - creating UNKNOWN service instance ".concat(ctor.name));
      }
    }
  }, {
    key: "_createServiceInstance",
    value: function _createServiceInstance(ctor) {
      var _this3 = this;

      var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      var _supportsDelayedInstantiation = arguments.length > 2 ? arguments[2] : undefined;

      var _trace = arguments.length > 3 ? arguments[3] : undefined;

      if (!_supportsDelayedInstantiation) {
        // eager instantiation
        return this._createInstance(ctor, args, _trace);
      } else {
        // Return a proxy object that's backed by an idle value. That
        // strategy is to instantiate services in our idle time or when actually
        // needed but not when injected into a consumer
        var idle = new IdleValue(function () {
          return _this3._createInstance(ctor, args, _trace);
        });
        return new Proxy(Object.create(null), {
          get: function get(target, key) {
            if (key in target) {
              return target[key];
            }

            var obj = idle.value;
            var prop = obj[key];

            if (typeof prop !== 'function') {
              return prop;
            }

            prop = prop.bind(obj);
            target[key] = prop;
            return prop;
          },
          set: function set(_target, p, value) {
            idle.value[p] = value;
            return true;
          }
        });
      }
    }
  }]);

  return InstantiationService;
}();

var Trace = /*#__PURE__*/function () {
  function Trace(type, name) {
    _classCallCheck(this, Trace);

    this.type = type;
    this.name = name;
    this._start = Date.now();
    this._dep = [];
  }

  _createClass(Trace, [{
    key: "branch",
    value: function branch(id, first) {
      var child = new Trace(2
      /* Branch */
      , id.toString());

      this._dep.push([id, first, child]);

      return child;
    }
  }, {
    key: "stop",
    value: function stop() {
      var dur = Date.now() - this._start;

      Trace._totals += dur;
      var causedCreation = false;

      function printChild(n, trace) {
        var res = [];
        var prefix = new Array(n + 1).join('\t');

        var _iterator4 = _createForOfIteratorHelper(trace._dep),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var _step4$value = _slicedToArray(_step4.value, 3),
                id = _step4$value[0],
                first = _step4$value[1],
                child = _step4$value[2];

            if (first && child) {
              causedCreation = true;
              res.push("".concat(prefix, "CREATES -> ").concat(id));
              var nested = printChild(n + 1, child);

              if (nested) {
                res.push(nested);
              }
            } else {
              res.push("".concat(prefix, "uses -> ").concat(id));
            }
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }

        return res.join('\n');
      }

      var lines = ["".concat(this.type === 0
      /* Creation */
      ? 'CREATE' : 'CALL', " ").concat(this.name), "".concat(printChild(1, this)), "DONE, took ".concat(dur.toFixed(2), "ms (grand total ").concat(Trace._totals.toFixed(2), "ms)")];

      if (dur > 2 || causedCreation) {
        console.log(lines.join('\n'));
      }
    }
  }], [{
    key: "traceInvocation",
    value: function traceInvocation(ctor) {
      return !_enableTracing ? Trace._None : new Trace(1
      /* Invocation */
      , ctor.name || ctor.toString().substring(0, 42).replace(/\n/g, ''));
    }
  }, {
    key: "traceCreation",
    value: function traceCreation(ctor) {
      return !_enableTracing ? Trace._None : new Trace(0
      /* Creation */
      , ctor.name);
    }
  }]);

  return Trace;
}();

Trace._None = new ( /*#__PURE__*/function (_Trace) {
  _inherits(_class, _Trace);

  var _super2 = _createSuper(_class);

  function _class() {
    _classCallCheck(this, _class);

    return _super2.call(this, -1, null);
  }

  _createClass(_class, [{
    key: "stop",
    value: function stop() {}
  }, {
    key: "branch",
    value: function branch() {
      return this;
    }
  }]);

  return _class;
}(Trace))();
Trace._totals = 0; //#endregion